import Service from '../Service'

export default class RelacionamentoService extends Service{

    constructor(){
        super('relacionamento');
    }
  
  }